<h3 class="race-percentage-title bold fund-allocation">Percentages of races funded per university</h3>
<section class="chart-container">
  <canvas #canvas id="fundedRacesChartId"> {{ fundedRacesChart }} </canvas>
</section>
